// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"7661456d","235":"131c873c","650":"afc9e9e7","715":"1f5f9486"}[chunkId] + ".chunk.js";
};